// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1p1dglyw{text-transform:none}\n._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}", ""]);
// Exports
module.exports = exports;
